<template>
  <div class="row">
    <div class="col-12">
      <portlet>
        <template slot="footer">
          <div class="row justify-content-center pt-4 pb-4">
            <bootstrap-pagination
              v-if="pagesGetter.page_total > 1"
              :total-page-number="pagesGetter.page_total"
              @number:updated="updateJobOpeningPage"
            />
          </div>
        </template>
        <div class="row">
          <div class="col">
            <button-wrapper
              class="mb-2"
              @click="addNewJobOpening"
            >
              新增職缺 <font-awesome-icon :icon="['far', 'plus-square']" />
            </button-wrapper>
            <button-wrapper
              class="mb-2"
              color="lighten_gray"
              @click="deleteCheckedJobs"
            >
              刪除已勾選項目 <font-awesome-icon :icon="['far', 'trash-alt']" />
            </button-wrapper>
          </div>
          <div class="col-sm-2 align-self-end">
            <form-select
              :options="identityOptions"
              select-name="identity_name"
              select-value="identity_value"
              name="identities"
              @change="identitySelected"
            />
          </div>
        </div>
        <table-wrapper class="table_scroll">
          <table-row class="table_width">
            <table-heading :cols="1" />
            <table-heading>
              標題
            </table-heading>
            <table-heading :cols="2">
              加入時間
            </table-heading>
            <table-heading :cols="1">
              截止日期
            </table-heading>
            <table-heading :cols="2">
              類型
            </table-heading>
            <table-heading :cols="1">
              狀態
            </table-heading>
            <table-heading :cols="1">
              開關
            </table-heading>
            <table-heading :cols="2">
              管理
            </table-heading>
          </table-row>
          <table-row
            class="table_width"
            v-for="job in jobs"
            :key="job.job_id"
            programmatic-navigation
          >
            <table-data :cols="1">
              <form-group
                cols="12"
              >
                <template slot="form-check">
                  <div class="form-check">
                    <check-input
                      v-model="cancel"
                      :value="job.job_id"
                      type="checkbox"
                      name="batch-cancel"
                    />
                  </div>
                </template>
              </form-group>
            </table-data>
            <table-data>
              {{ job.job_title }}
            </table-data>
            <table-data :cols="2">
              {{ job.job_created_at || new Date() | moment("YYYY/MM/DD HH:mm:ss") }}
            </table-data>
            <table-data :cols="1">
              {{ job.job_publishing_deadline || new Date() | moment("YYYY/MM/DD") }}
            </table-data>
            <table-data :cols="2">
              <tag :is-wide="false">
                {{ job.job_identity }}
              </tag>
            </table-data>
            <table-data
              :cols="1"
              :class="{
                'text-success': job.job_opening_status === true,
                'text-warning': job.job_opening_status === false,
              }"
            >
              {{ job.job_opening_status | openingStatus }}
            </table-data>
            <table-data :cols="1">
              <form-group
                cols="12"
              >
                <template slot="form-check">
                  <div class="form-check mt-2">
                    <check-input
                      v-model="job.job_opening_status"
                      :value="job.job_id"
                      type="switch"
                      :name="`deadline-switch-${job.job_id}`"
                      @change="switchDeadline(job.job_id, $event)"
                    />
                  </div>
                </template>
              </form-group>
            </table-data>
            <table-data :cols="2">
              <button-wrapper
                color="lighten_gray"
                @click="editJobOpening($event, job.job_id)"
              >
                編輯 <font-awesome-icon :icon="['far', 'edit']" />
              </button-wrapper>
            </table-data>
          </table-row>
        </table-wrapper>
      </portlet>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import BootstrapPagination from '~bootstrap/Pagination'
import Portlet from '~components/common/Portlet'
import TableWrapper from '~components/common/tables'
import TableRow from '~components/common/tables/Row'
import TableHeading from '~components/common/tables/Heading'
import TableData from '~components/common/tables/Data'
import Tag from '~components/common/Tag'
import FormGroup from '~components/common/form/Group'
import ButtonWrapper from '~components/common/buttons'
import FormSelect from '~components/common/form/Select'
import CheckInput from '~components/common/form/input/Check'
import { openingStatus } from '~utils/filters'
export default {
  name: 'ManagingJobOpenings',
  components: {
    BootstrapPagination,
    Portlet,
    TableWrapper,
    TableRow,
    TableHeading,
    TableData,
    Tag,
    ButtonWrapper,
    CheckInput,
    FormGroup,
    FormSelect
  },
  filters: {
    openingStatus
  },
  data () {
    return {
      cancel: [],
      currentIdentity: '',
      identityOptions: [{
        identity_name: '全部',
        identity_value: ''
      }],
      jobs: []
    }
  },
  computed: {
    ...mapGetters('pages/enterprises', [
      'enterpriseJobsGetter',
      'pagesGetter'
    ]),
    ...mapGetters('pages/jobs', [
      'identitiesGetter'
    ])
  },
  watch: {
    enterpriseJobsGetter (value) {
      this.jobs = value
    }
  },
  async created () {
    await this.getEnterpriseJobList()
    await this.getIdentities()
    this.identityOptions = this.identityOptions.concat(this.identitiesGetter)
  },
  methods: {
    ...mapActions('pages/enterprises', [
      'getEnterpriseJobList',
      'removeJobOpenings',
      'updateJobOpening'
    ]),
    ...mapActions('pages/jobs', [
      'getIdentities'
    ]),
    updateJobOpeningPage (page) {
      const params = this.currentIdentity ? { identity: this.currentIdentity } : {}
      this.getEnterpriseJobList({ page, ...params })
    },
    editJobOpening (e, id) {
      this.$router.push({
        path: `/enterprises/job-openings/${id}`
      })
    },
    identitySelected (identity) {
      this.currentIdentity = identity.identity_value
      if (this.currentIdentity) {
        this.getEnterpriseJobList({
          identity_id: identity.identity_value
        })
      } else {
        this.getEnterpriseJobList()
      }
    },
    async deleteCheckedJobs () {
      await this.removeJobOpenings(this.cancel)
      await this.getEnterpriseJobList()
    },
    addNewJobOpening () {
      this.$router.push({
        path: '/enterprises/job-openings'
      })
    },
    switchDeadline (jobId) {
      const index = this.jobs.findIndex(job => job.job_id === jobId)
      const jobBefore = this.jobs[index]

      let jobAfter = {}
      if (!jobBefore.job_opening_status) {
        jobAfter = Object.assign({}, jobBefore, {
          job_opening_status: false,
          job_publishing_deadline: this.$moment().toISOString()
        })
      } else {
        jobAfter = Object.assign({}, jobBefore, {
          job_opening_status: true,
          job_publishing_deadline: ''
        })
      }
      this.jobs.splice(index, 1, jobAfter)
      this.toggleDeadline(jobId, jobAfter)
    },
    async toggleDeadline (jobId, job) {
      await this.updateJobOpening({
        id: jobId,
        job: {
          job_publishing_deadline: job.job_publishing_deadline
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
    .table_scroll{
        overflow-x:scroll!important;
    }
    .table_width{
        width: 1000px;
    }

</style>
